import React from "react";
import LoadingOverlay from "react-loading-overlay";
LoadingOverlay.propTypes = undefined;

const FullScreenLoadingOverlay = ({
  showFullScreenLoadingOverlay,
  textFullScreenLoadingOverlay
  }) => {

  return <div className={`${showFullScreenLoadingOverlay ? 'full_screen_loading_overlay' : ''}`}>
    <LoadingOverlay
      className="loading-spinner"
      active={showFullScreenLoadingOverlay}
      spinner
      text={textFullScreenLoadingOverlay}
    />
  </div>
};

export default FullScreenLoadingOverlay;